// Inaugration images
import inaugImage1 from './../resources/images/inauguration/image1.jpg';
import inaugImage2 from './../resources/images/inauguration/image2.jpg';
import inaugImage3 from './../resources/images/inauguration/image3.jpg';
import inaugImage4 from './../resources/images/inauguration/image4.jpg';
import inaugImage5 from './../resources/images/inauguration/image5.jpg';
import inaugImage6 from './../resources/images/inauguration/image6.jpg';
import inaugImage7 from './../resources/images/inauguration/image7.jpg';

// TechnoGrad Images
import technogradLogoFull from './../resources/images/technograd23/1_technogradLogoFull.jpg'
import techno23Img2 from './../resources/images/technograd23/2_Group.jpg'
import techno23Img3 from './../resources/images/technograd23/3_Crowd.jpg'
import techno23Img4 from './../resources/images/technograd23/4_Winners.jpg'
import techno23Img5 from './../resources/images/technograd23/5_Ludo.jpg'
import techno23Img6 from './../resources/images/technograd23/6_Singers.jpg'
import techno23Img7 from './../resources/images/technograd23/7_Group_2.jpg'
import techno23Img8 from './../resources/images/technograd23/8_Crowd_2.jpg'
import techno23Img9 from './../resources/images/technograd23/9_Batman.jpg'

// Design Dojo Images
import dojoImage1 from './../resources/images/designdojo/1_logo.jpg'
import dojoImage2 from './../resources/images/designdojo/2_poster.jpg'
import dojoImage3 from './../resources/images/designdojo/3_project.jpg'
import dojoImage4 from './../resources/images/designdojo/4_workshop.jpg'
import dojoImage5 from './../resources/images/designdojo/5_audience.jpg'

// Synergy Images
import synergyImg1 from './../resources/images/synergy/1_synergyLogo.jpg'
import synergyImg2 from './../resources/images/synergy/2_entrance.jpg'
import synergyImg3 from './../resources/images/synergy/3_codingEnd.jpg'
import synergyImg10 from './../resources/images/synergy/10_finalRound.jpg'
import synergyImg4 from './../resources/images/synergy/4_firstPlace.jpg'
import synergyImg5 from './../resources/images/synergy/5_secondPlace.jpg'
import synergyImg6 from './../resources/images/synergy/6_thirdPlace.jpg'
import synergyImg7 from './../resources/images/synergy/7_nsdcGroup.jpg'
import synergyImg8 from './../resources/images/synergy/8_synergyGroup.jpg'
import synergyImg9 from './../resources/images/synergy/9_Batman.jpg'


export const eventIndexConstants = {
    INAUGRATION: 0,
    TECHNOGRAD23: 1,
    DESIGNDOJO: 2,
    SYNERGY: 3,
}

const eventsDetails = [
    {
        name: "DJS-NSDC INAUGURATION",
        images: [inaugImage1, inaugImage2, inaugImage3, inaugImage4, inaugImage5, inaugImage6, inaugImage7],
        date: new Date('April 18, 2023 09:30:00'),
        endDate: new Date('April 18, 2023 09:30:00'),
        time: "9:30 a.m. - 11:30 a.m.",
        description: "Celebrating the successful inauguration of our new student chapter, DJS NSDC, dedicated to exploring the exciting fields of data science and machine learning. Our inaugural event featured an engaging talk on Cloud AI/ML by an esteemed industry expert. Attendees had the exclusive opportunity to delve into the latest trends and gain valuable insights into the dynamic world of data science and machine learning.",
        url: "/events/inauguration",
        keyPoints: [
            "Felicitation by our dear Principal sir Dr. Hari Vasudevan.",
            "New student chapter introduced.",
            "An engaging talk on Cloud AI/ML by an esteemed industry expert.",
            "Core Revealed."
        ],
        followsTemplate: true
    },
    {
        name: "TechnoGrad 1.0",
        images: [technogradLogoFull, techno23Img2, techno23Img3, techno23Img4, techno23Img5, techno23Img6, techno23Img7, techno23Img8, techno23Img9],
        date: new Date('September 15, 2023 10:00:00'),
        endDate: new Date('September 16, 2023 12:30:00'),
        time: "10:00 a.m.",
        description: "In the ever-evolving world of technology, there's a place where innovation knows no bounds and inspiration flows freely. We're thrilled to unveil TECHNOGRAD, a groundbreaking event brought to you by DJS-NSDC. Set your calendars for two electrifying days, where we dive deep into the heart of all things tech. Get ready for an experience that blends knowledge, creativity, and camaraderie in the most exciting ways.",
        url: "/events/technograd-23",
        followsTemplate: false
    },
    {
        name: "DESIGN DOJO",
        images: [dojoImage1, dojoImage2, dojoImage3, dojoImage4, dojoImage5],
        date: new Date('November 03, 2023 12:00:00'),
        endDate: new Date('November 03, 2023 04:00:00'),
        time: "12:00 p.m. - 04:00 p.m.",
        description: "Delve into the realm of UI/UX design with our exclusive workshop, 'Design Dojo'. This workshop offered hands-on experience using Figma to create a fitness application, 'Ukiyo.' Participants gained insights into fundamental UI/UX concepts and now have a tangible project & certificate of completion, to add great value to their portfolios.",
        url: "/events/design-dojo",
        keyPoints: [
            "Expert guidance by Srijan Upadhyay and Vritti Shah.",
            "Hands-on Figma experience creating 'Ukiyo.'",
            "Explored UI/UX Fundamentals, Prototyping, Wireframing, & many other concepts.",
            "Participants leave with a tangible project for their portfolios."
        ],
        followsTemplate: true
    },
    {
        name: "SYN3RGY-24Hr Hackathon",
        images: [synergyImg1, synergyImg2, synergyImg3, synergyImg10, synergyImg4, synergyImg5, synergyImg6, synergyImg7, synergyImg8, synergyImg9],
        date: new Date('February 24, 2023 07:00:00'),
        endDate: new Date('February 25, 2023 19:30:00'),
        time: "07:00 a.m. - 07:30 p.m.",
        description: "Collaborative innovation by DJS NSDC, DJS SIGAI, and DJS ISACA. A 24-hour intense competition",
        url: "https://syn3rgy.vercel.app/",
        keyPoints: [
            "Collaborative innovation by DJS NSDC, DJS SIGAI, and DJS ISACA.",
            "24-hour intense competition fostering teamwork and creativity.",
            "Based on LEGO Theme, creating a uniquely innovative environment.",
            "Teams engage in a spirited battle for a coveted spot among the top 10.",
            "Diverse tech domains: Data Science, AI/ML, Blockchain, Cybersecurity, Web/App Dev, Open Innovation.",
        ],
        followsTemplate: true
    },
]

export default eventsDetails